<template>
  <div ref="fotoPortadaRef" class="fotoportada-container">
    <div class="overlay">
      <br> <br>

      <!-- SECCIÓN CHAMBELANES -->
      <div ref="chambelanesRef" class="corte-seccion">
        <h3 class="corte-titulo anim-item">Mis Padrinos:</h3>

        <ul class="corte-lista">
          <li class="anim-item">Humberto</li>

          <li class="anim-item ampersand-item">
            <img
              src="@/assets/ampersand.png"
              alt="&"
              class="ampersand-img"
            >
          </li>

          <li class="anim-item">Annie</li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'InvitacionQuinceanera',

  setup() {
    const fotoPortadaRef = ref(null)
    const chambelanesRef = ref(null)
    let ctx = null

    onMounted(() => {
      // Contexto de GSAP para un manejo eficiente de memoria en Vue
      ctx = gsap.context(() => {
        const items = chambelanesRef.value.querySelectorAll('.anim-item')

        // Animación activada únicamente al entrar al Viewport
        gsap.from(items, {
          scrollTrigger: {
            trigger: chambelanesRef.value,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
          opacity: 0,
          y: 45,
          scale: 0.9,
          duration: 1.1,
          stagger: 0.25,
          ease: 'power3.out'
        })
      }, fotoPortadaRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      fotoPortadaRef,
      chambelanesRef
    }
  }
}
</script>

<style scoped>

/* ==========================================
   1. ESTILOS BASE Y CONTENEDORES
   ========================================== */

.fotoportada-container {
  position: relative;
  width: 100%;
  min-height: 50vh;
  overflow: visible;
  background-color: #fff;
  z-index: 1;
  margin-top: -100px;
}

.overlay {
  position: relative;
  width: 100%;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  z-index: 2;
}

/* ==========================================
   2. SECCIÓN CHAMBELANES
   ========================================== */

.corte-seccion {
  width: 100%;
  max-width: 450px;
  text-align: center;
  z-index: 4;
}

.corte-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #B28F60;
  margin-bottom: 24px;
  will-change: transform, opacity;
}

.corte-lista {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.corte-lista li {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  font-weight: 600;
  color: #d789df;
  letter-spacing: 1px;
  will-change: transform, opacity;
}

/* ==========================================
   3. AMPERSAND
   ========================================== */

.ampersand-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ampersand-img {
  width: 28px;
  height: auto;
  display: block;
  object-fit: contain;
}

</style>